module.exports = __webpack_public_path__ + "static/media/GloberBold.cbf7fcaa.woff";